module.exports=function(scope){ return `var https = require("https");
var data = JSON.stringify({
  "faceMap": INSERT_FACEMAP_DATA_AS_BASE64_HERE,
  "idScan": INSERT_ID_SCAN_HERE,
  "idScanFrontImage": INSERT_ID_SCAN_FRONT_IMAGE_HERE,
  "idScanBackImage": INSERT_ID_SCAN_BACK_IMAGE_HERE
})

callFaceTecAPI(data, "/id-check", function(error, result) {
  if(error) {
    console.log("Error:" + error);
  }
  else if(result) {
    console.log(result)
  }
})

function callFaceTecAPI(data, path, callback){
  var options = {
    hostname: "your.internal.zoomserver.instance.url",
    port: 443,
    path: path,
    method: "POST",
    headers: {
        "Content-Type": "application/json",
        "X-User-Agent": INSERT_X_USER_AGENT_VALUE_HERE
    }
  }

  var req = https.request(options, (res) => {
      var output = ""

      res.on("data", (d) => {
          output += d
      })

      res.on("end", () => {
        try{
          var obj = JSON.parse(output)
          callback(undefined, obj.data)
        }
        catch(error) {
          callback(error, undefined)
        }
      })
  })

  req.on("error", (error) => {
    callback(error, undefined)
  })

  req.write(data)
  req.end()
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/nodejs/id-check.js.tpl